<script setup>
import { computed } from 'vue';

// Whether a case is still open is the first thing an agent wants from a search
// result, and reading it from the text was slowing them down. Colour carries
// it: green is done, amber still needs someone.
const props = defineProps({
  status: {
    type: String,
    default: '',
  },
});

const STYLES = {
  resolved: 'bg-n-teal-3 text-n-teal-11 dark:bg-n-teal-3 dark:text-n-teal-11',
  open: 'bg-n-amber-3 text-n-amber-11 dark:bg-n-amber-3 dark:text-n-amber-11',
  pending: 'bg-n-amber-3 text-n-amber-11 dark:bg-n-amber-3 dark:text-n-amber-11',
  snoozed: 'bg-n-slate-3 text-n-slate-11 dark:bg-n-slate-3 dark:text-n-slate-11',
};

// Pending and snoozed are not resolved, so they read amber like open rather
// than inventing a third colour nobody has been taught.
const classes = computed(() => STYLES[props.status] ?? STYLES.snoozed);

const label = computed(() => {
  if (!props.status) return '';
  return props.status.charAt(0).toUpperCase() + props.status.slice(1);
});
</script>

<template>
  <span
    v-if="label"
    class="flex-shrink-0 rounded-md px-1.5 py-0.5 text-xs font-medium leading-4"
    :class="classes"
  >
    {{ label }}
  </span>
</template>
